import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const MarketingEventsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "MarketingEvents",
    children: /*#__PURE__*/_jsx("path", {
      d: "M27.05 6.52h-5.27l.13-1.12a.41.41 0 0 0-.35-.46h-1.11c-.16-.31-.36-.59-.6-.83C18.72 2.98 17.3 2 14.21 2c-6 .04-10.84 4.93-10.8 10.94v.32c0 2.11 0 6.55 3.41 6.55.77.09 1.53-.2 2.04-.78 1.22-1.62.54-5.36.31-6.65-.19-1.05-.23-5.27.76-6.32a6.12 6.12 0 0 1 4.68-2.64c1.45-.18 2.91.26 4.01 1.22.13.11.26.19.37.29h-.64c-.23 0-.41.18-.42.4v.08l.72 4.67c.03.2.2.36.41.36h1.91c.21 0 .38-.16.41-.37l.11-.82h2.33c.49 0 .9.4.9.9v.08c0 .49-.4.89-.9.9h-7.76c-.5 0-.9-.4-.91-.9v-.07c0-.5.41-.91.91-.91h1.63l-.42-2.74h-4.64c-.86 0-1.55.69-1.55 1.55v20.38c0 .86.69 1.55 1.55 1.55h14.42c.85 0 1.54-.69 1.54-1.54V8.07c0-.85-.68-1.54-1.53-1.55zM8.79 5.57c-1.17 1.19-1.17 4.39-1.01 6.38s.72 2.71.43 5.01c-.11.84-.51 1.54-1.36 1.54-1.5 0-2.11-1.86-2.11-5.27 0-3.84 2.56-7.88 4.52-8.43.23.15-.28.53-.47.76Zm11.12 16.48a4.213 4.213 0 0 1-4.27-4.16 4.213 4.213 0 0 1 4.16-4.27 4.213 4.213 0 0 1 4.27 4.16v.1a4.21 4.21 0 0 1-4.16 4.16Z"
    })
  }));
};